import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { RastraPopup } from "./RastraPopup";

export default function Rastra() {
   const { loading, data } = useCollection("rastra");
   const columns = [
      {
         title: "Grams",
         dataIndex: "grams",
      },
      {
         title: "Lineatura",
         dataIndex: "lineatura",
         align: "center",
      },
      {
         render: (value) => <RastraPopup grams={value.grams} lineatura={value.lineatura} id={value.id} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
